/**
 * options {className, attrs, html, text, children}
 */
export function createElement(tagName, options = {}, children = []) {
  let el;

  if (!tagName) {
    el = document.createDocumentFragment();
  } else {
    el = document.createElement(tagName);

    if (options.className) {
      el.className = options.className;
    }

    if (options.id) {
      el.id = options.id;
    }

    if (options.attrs) {
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const attr in options.attrs) {
        el.setAttribute(attr, options.attrs[attr]);
      }
    }

    // html and innerHTML are aliases
    let { html } = options;
    if (html === undefined) {
      html = options.innerHTML;
    }
    if (html !== undefined) {
      el.innerHTML = html;
    }
  }

  if (options.text) {
    el.appendChild(document.createTextNode(options.text));
  }

  if (window.HTMLElement === undefined) {
    window.HTMLElement = Element;
  }

  if (children && children.length) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      el.appendChild(child instanceof window.HTMLElement ? child : createElement(child.tagName, child, child.children));
    }
  }

  if (options.events) {
    // eslint-disable-next-line no-restricted-syntax
    for (const event of Object.keys(options.events)) {
      el.addEventListener(event, options.events[event]);
    }
  }

  return el;
}

export function div(options, children) {
  return createElement('div', options, children);
}

export function span(options, children) {
  return createElement('span', options, children);
}

// selectorsOrElements: array of string selectors or html elements, can't be mixed
export function toggleElementsVisibility(selectorsOrElements, hidden) {
  if (!selectorsOrElements || !selectorsOrElements.length) {
    return;
  }

  let elements = selectorsOrElements;
  if (typeof selectorsOrElements[0] === 'string') {
    const selectors = selectorsOrElements.join(',');
    elements = Array.from(document.querySelectorAll(selectors));
  }

  elements.forEach(el => {
    if (el) {
      if (hidden) {
        el.classList.add('hidden');
        el.hidden = true; // eslint-disable-line no-param-reassign
      } else {
        el.classList.remove('hidden');
        el.hidden = false; // eslint-disable-line no-param-reassign
      }
    }
  });
}

export function showElements(...selectorsOrElements) {
  toggleElementsVisibility(selectorsOrElements, false);
}

export function hideElements(...selectorsOrElements) {
  toggleElementsVisibility(selectorsOrElements, true);
}
